import React from "react";
import Tel from "./Tel";
function TelList(props) {
  const rx = /(\(([2-9][0-9][0-9])\) ([2-9][0-9][0-9])-([0-9][0-9][0-9][0-9]))/g;
  const ret = [];
  const arr = props.phone ? props.phone.replace(rx, (a, b, c, d, e) => {
    ret.push([c, d, e]);
    return "|";
  }).split("|") : [];
  return (
    <div className="attribute staff-phone">
      {arr.map((a, n) => (
        <React.Fragment key={n}>
          {arr[n]}
          <Tel num={ret[n]}></Tel>
        </React.Fragment>
      ))}
    </div>
  );
}
export default TelList;
